import React from "react";
import { CircularProgress } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export default function LoaderCircle({color}) {
  const useStyles = (props) =>
    makeStyles((theme) => ({
      paperContainer: {
        //height: '760px',
        height: "100%",
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        color: !color ? theme.palette.primary.main : color
      },
    }));
  const propswindows = {
    screen: window.screen.width,
  };
  const classes = useStyles(propswindows)();

  return (
    <Grid container className={classes.paperContainer}>
      <Grid
        item
        xs={12}
        style={{
          textAlign: "center",
          minHeight: "200px",
          padding: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          size={50}
          thickness={3.0}
          color={"inherit"}
          open={true}
        />
      </Grid>
    </Grid>
  );
}
